<div class="searchbar border-grey-1 bg-color-white" id="barra-pesquisa-instituicoes-olinda"
  aria-label="pesquisarEmCursos" role="searchbox">
  <form [formGroup]="formularioPesquisa">
    <div class="input-container" role="none">
      <h4>Curso: {{ nomeCurso }}</h4>
      <button (click)="listarTodasInstituicoesCache()" value="buscar todos"
        class="btn-listar-todos btn btn-md btn-dark rounded-pill cursor-pointer">
        buscar todos
      </button>
      <span role="separator" class="vert-line"></span>
      <button type="button" class="filters-btn cursor-pointer" (click)="toggle = !toggle" *ngIf="ufs">
        filtros <span role="img" class="filter-toggle"></span>
      </button>
    </div>
    <hr class="bg-color-dark-grey hr-line" *ngIf="toggle && ufs" />
    <div class="filters" [ngClass]="{ open: toggle && ufs }">
      <!-- keydown e keyup-->
      <div class="form-group">
        <label class="form-label">Nome da instituição:</label>
        <input formControlName="stringBusca" type="search" class="input searchbar color-dark bg-color-white"
          id="busca-{{ componenteAtual }}" placeholder="Termo de busca" name="StringBusca" [value]="searchString"
          (keyup)="onChangeBuscarInstituicaoCache($event)" (keydown.enter)="onEnterPress($event)"
          (input)="onInput($event)" />
      </div>

      <div class="form-group">
        <label class="form-label">UF:</label>
        <select formControlName="siglaUF" class="select form-control" id="uf" (change)="onChangeSelectUF($event)">
          <option [value]="null" selected>Selecione uma UF</option>
          <option *ngFor="let uf of ufs" [value]="uf.sigla">{{ uf.descricao }}</option>
        </select>
      </div>

      <div class="form-group">
        <label class="form-label">MUNICÍPIO:</label>
        <select formControlName="codMunicipio" class="form-control select" id="municipio"
          (change)="onChangeMunicipio($event)">
          <option [value]="null" selected></option>
          <option *ngFor="let m of municipios" [value]="m.id">{{ m.nome }}</option>
        </select>
      </div>

      <div class="form-group">
        <button type="button" class="btn btn-md btn-dark rounded-pill cursor-pointer" (click)="onLimparPesquisar()">
          Limpar
        </button>
      </div>

      <!-- <div class="form-group">
        <button type="submit" class="btn btn-md btn-dark rounded-pill cursor-pointer" (click)="onPesquisar()">
          Aplicar filtro
        </button>
      </div> -->
    </div>
  </form>
</div>